import { render } from "./pre-receiving.vue?vue&type=template&id=599bb8f2"
import script from "./pre-receiving.vue?vue&type=script&lang=js"
export * from "./pre-receiving.vue?vue&type=script&lang=js"

import "./pre-receiving.vue?vue&type=style&index=0&id=599bb8f2&lang=css"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__